import { observer } from "mobx-react";
import React, { forwardRef } from "react";
import accessibleTabs from "../Tabs/AccessibleTabs";
import PerformanceStore from "../../store/PerformanceStore";
import { derivativeFixTab, derivativeTabs } from "../../utils/data";
import { setDerivativeTabKeys } from "../../utils/functions";

const DurationTabs = observer(
  forwardRef(
    (
      { tabs, selectedTab, selectedIndex, handleTab, handleKeyDown },
      tabRefs,
    ) => {
      return (
        <div className="tabs int_tabs performance">
          <div role="tablist" aria-label="Tabs" className="tab-list">
            {tabs.map((tabsData, index) => (
              <button
                key={tabsData}
                ref={(el) => (tabRefs.current[index] = el)}
                id={tabsData}
                role="tab"
                aria-selected={selectedIndex === index}
                aria-controls={`panel-${index}`}
                tabIndex={selectedIndex === index ? 0 : -1}
                className={`tab-list-item ${
                  selectedTab &&
                  (selectedTab === tabsData ||
                    selectedTab === setDerivativeTabKeys(index))
                    ? "is-active darkBlueTextColor"
                    : selectedTab === "" && index === 0
                      ? "is-active darkBlueTextColor"
                      : "blueTextColor"
                }`}
                onClick={() => handleTab({ tab: tabsData, index })}
                onKeyDown={(e) => handleKeyDown({ e, index, tab: tabsData })}
              >
                <p className="tab-name">
                  {!derivativeFixTab?.includes(tabsData)
                    ? tabsData
                    : PerformanceStore.subTabs?.[
                        derivativeTabs.indexOf(tabsData)
                      ]}
                </p>
              </button>
            ))}
          </div>
        </div>
      );
    },
  ),
);

export default accessibleTabs(DurationTabs);
